enum ROLE_ID {
  ADMIN = 1,
  MENTOR = 2,
  MENTEE = 3,
  GUEST = 4,
  UNAPPROVED = 5,
}

enum ROLE_NAME {
  ADMIN = 'ROLE_ADMIN',
  MENTOR = 'ROLE_MENTOR',
  MENTEE = 'ROLE_MENTEE',
  GUEST = 'ROLE_GUEST',
  UNAPPROVED = 'ROLE_UNAPPROVED',
}
export { ROLE_ID, ROLE_NAME };
